import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    className?: string;
}

export const Confirm: FunctionComponent<OwnProps> = ({className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Confirm your email address</h5>
            </div>
            <div className="card-body">
                <p>
                    To keep your crew secure you need confirm your email address. Please check your inbox for the
                    confirmation email. If you did not receive the email, please click the button below to resend it.{' '}
                </p>
            </div>
            <div className="card-footer">
                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <a href="/account/confirmation/resend" className="btn btn-primary">
                            Resend confirmation email
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
